import { Injectable } from '@angular/core';
 import { BehaviorSubject } from 'rxjs';


@Injectable()
export class LanguageTranslateObservableService {
    public LanguageSelected = new BehaviorSubject< string >('en');
    cast = this.LanguageSelected.asObservable();
constructor() { }
selectedLang
languageChanged(data){
    this.selectedLang = data;
    if(data=="English")
    {
this.LanguageSelected.next('en');
}
else
{
    this.LanguageSelected.next('arb');
}
}

}



// WEBPACK FOOTER //
// ./src/app/shared/languageTranslateObservable.service.ts